import { CSSProperties } from 'react'
import { cva } from 'class-variance-authority'
import type { VariantProps } from 'class-variance-authority'

const $skeleton = cva(
  'relative overflow-hidden bg-dark-shade before:absolute before:inset-0 before:-translate-x-full before:animate-loading-skeleton before:bg-loading',
  {
    variants: {
      size: {
        md: 'rounded',
        lg: 'rounded-lg',
      },
      borderless: {
        false: 'border border-dark-border-solid',
      },
    },
    defaultVariants: {
      size: 'md',
      borderless: false,
    },
  }
)

export const Skeleton = ({
  className,
  height,
  width,
  style,
  ...rest
}: {
  className?: string
  height: CSSProperties['height']
  width?: CSSProperties['width']
  style?: CSSProperties
} & VariantProps<typeof $skeleton>) => {
  return (
    <div
      className={$skeleton({ className, ...rest })}
      style={{ width, height, ...style }}
    />
  )
}
